import artHeadLine from "../../../assets/arteHeadlineConfig.png";
import AddRolesUsers from "../../../components/AddRolesUsers";
import RegisterProducts from "../../../components/RegisterProducts";
import AddSuppliers from "../../../components/AddSuppliers";
import AddContainers from "../../../components/AddContainers";
import settingsBottom from "../../../assets/settingsBottom.png";
import Prevision from "../../../components/Prevision";
import productIcon from "../../../assets/productIcon.png";

import { useEffect, useState } from "react";
import useProductStore from "../../../store/productStore";
import useUserStore from "../../../store/userStore";
import useSupplierStore from "../../../store/supplierStore";
import useContainerStore from "../../../store/containerStore";
import DeleteButton from "../../../components/DeleteButton";
import AddPaymentMethod from "../../../components/AddPaymentMethod";
import usePaymentMethodStore from "../../../store/paymentMethodStore";

const Configuracao = () => {
  const { loading, error, getAllProducts } = useProductStore();

  const {
    getAllPaymentMethods,
    paymentMethods,
    addPaymentMethod,
    updatePaymentMethod,
    removePaymentMethod,
  } = usePaymentMethodStore();

  const {
    users,
    loading: userLoading,
    error: userError,
    getAllUsers,
    addUser,
    updateUser,
    removeUser,
  } = useUserStore();

  //TODO: ver como iremos controlar o loading dos 4 elementos.

  const {
    addSupplier,
    suppliers,
    getAllSuppliers,
    updateSupplier,
    removeSupplier,
  } = useSupplierStore();
  const {
    addContainer,
    containers,
    getAllContainers,
    removeContainer,
    updateContainer,
  } = useContainerStore();

  useEffect(() => {
    getAllProducts();
  }, [getAllProducts]);

  useEffect(() => {
    getAllUsers();
  }, [getAllUsers]);

  useEffect(() => {
    getAllSuppliers();
  }, [getAllSuppliers]);

  useEffect(() => {
    getAllContainers();
  }, [getAllContainers]);
  useEffect(() => {
    getAllPaymentMethods();
  }, [getAllPaymentMethods]);

  if (loading) {
    return <p>Carregando...</p>;
  }

  if (error) {
    return <p>Erro ao carregar produtos: {error}</p>;
  }

  return (
    <>
      {/* flex justify-between */}
      <div className=" text-boldGray opacity-90">
        <AddRolesUsers
          users={users}
          addUser={addUser}
          updateUser={updateUser}
          removeUser={removeUser}
        />
      </div>
      <div className="grid md:grid-cols-2 xl:grid-cols-3">
        <AddSuppliers
          suppliers={suppliers}
          addSupplier={addSupplier}
          updateSupplier={updateSupplier}
          removeSupplier={removeSupplier}
        />
        <AddContainers
          addContainer={addContainer}
          containers={containers}
          removeContainer={removeContainer}
          updateContainer={updateContainer}
        />
        <AddPaymentMethod
          paymentMethods={paymentMethods}
          addPaymentMethod={addPaymentMethod}
          updatePaymentMethod={updatePaymentMethod}
          removePaymentMethod={removePaymentMethod}
        />
      </div>
      <div className=" relative z-0  text-boldGray opacity-90">
        <div className="flex ml-auto z-0 absolute bottom-0 right-0">
          <img
            className="object-contain hidden xl:block lg:h-[360px] xl:h-[360px] 2xl:h-[450px] "
            src={settingsBottom}
            alt=""
          />
        </div>
        <Prevision />
      </div>
    </>
  );
};

export default Configuracao;
